const SEUIL = 6;
const HAUT = 80;
const BAS = 40;

export function nextTabbarHidden(
  state: { y: number; hidden: boolean },
  y: number,
  viewport: number,
  docHeight: number,
  reduce: boolean,
  typing: boolean,
): boolean {
  if (typing) return true;
  if (reduce) return false;
  if (y < HAUT || y + viewport >= docHeight - BAS) return false;
  if (y > state.y + SEUIL) return true;
  if (y < state.y - SEUIL) return false;
  return state.hidden;
}

export function initTabbar(bar: HTMLElement | null, win: Window = window): void {
  if (!bar || bar.dataset.kmReady === "1") return;
  bar.dataset.kmReady = "1";
  const doc = win.document;
  const reduce = win.matchMedia?.("(prefers-reduced-motion: reduce)");
  const state = { y: win.scrollY, hidden: false };
  let typing = false;
  let frame = 0;

  const update = () => {
    frame = 0;
    const y = win.scrollY;
    const hidden = nextTabbarHidden(state, y, win.innerHeight, doc.documentElement.scrollHeight, reduce?.matches ?? false, typing);
    state.y = y;
    if (hidden !== state.hidden) {
      state.hidden = hidden;
      bar.classList.toggle("is-hidden", hidden);
    }
  };
  const schedule = () => { if (!frame) frame = win.requestAnimationFrame(update); };
  const isField = (t: EventTarget | null) => t instanceof HTMLElement && t.matches("input, textarea, select, [contenteditable]");

  win.addEventListener("scroll", schedule, { passive: true });
  doc.addEventListener("focusin", (e) => { if (isField(e.target)) { typing = true; schedule(); } });
  doc.addEventListener("focusout", (e) => { if (isField(e.target)) { typing = false; schedule(); } });
}
